module.exports = __webpack_public_path__ + "assets/img/1491587607662_.pic_hd.0b8b17b1.jpg";